/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_DATA_TABLE_ACCESS_MENU,
    REQUEST_DATA_TABLE_ACCESS_MENU_FAILURE,
    REQUEST_DATA_TABLE_ACCESS_MENU_SUCCESS
} from "../../constant/UserAccessMenuConstant";

const initialState = {
    userAccessMenuTableData: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const userAccessMenuDataTableReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_DATA_TABLE_ACCESS_MENU:
            return {
                ...state,
                userAccessMenuTableData: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_DATA_TABLE_ACCESS_MENU_SUCCESS:
            return {
                ...state,
                userAccessMenuTableData: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_DATA_TABLE_ACCESS_MENU_FAILURE:
            return {
                ...state,
                userAccessMenuTableData: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
